import Form  from "../../../Lib/Forms/Form";
import store from '../../../store';
import User  from "../Store/User";

export default class LoginForm extends Form {

    constructor() {
        super();
        this.email = '';
        this.password = '';
    }

    rules() {
        return {
            email   : ['required', 'email'],
            password: ['required'],
        }
    }

    async submit() {
        let userStore = new User();

        return userStore.login(this.email, this.password);
    }


}
